import { useEffect, useState } from "react";
import { getTurnosPorPaciente } from "../../api/apiResources";
import { BadgeEstado, formatFechaHora } from "../utils/MedicoUtils";
import { IconCalendar, IconClock, IconMapPin, IconStethoscope } from "../icons/IconsMedico";
import "./HistorialPacienteModal.css";
import Modal from "../modals/Modal";

const HistorialPacienteModal = ({ paciente, onClose }) => {
    const [turnos, setTurnos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!paciente?.id) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError("");
        getTurnosPorPaciente(paciente.id)
            .then((data) => setTurnos(data))
            .catch((e) => setError(e.message || "Error al cargar el historial."))
            .finally(() => setLoading(false));
    }, [paciente?.id]);

    const nombrePaciente = paciente?.nombre || "Paciente";
    const turnosOrdenados = [...turnos].sort((a, b) => new Date(b.fechaHora) - new Date(a.fechaHora));
    const planInfo = paciente?.raw?.plan;

    return (
        <Modal title={`Historial de ${nombrePaciente}`} onClose={onClose}>
            <div className="historial-modal">

                <div className="historial-modal__paciente">
                    <div className="historial-modal__avatar">
                        {nombrePaciente.charAt(0).toUpperCase()}
                    </div>
                    <div className="historial-modal__paciente-info">
                        <p className="historial-modal__paciente-nombre">{nombrePaciente}</p>
                        {planInfo ? (
                            <div className="historial-modal__plan">
                                <span className="historial-modal__plan-label">Plan:</span>
                                <span className="historial-modal__plan-nombre">{planInfo.nombre}</span>
                                {Array.isArray(planInfo.coberturas) && planInfo.coberturas.length > 0 && (
                                    <div className="historial-modal__coberturas">
                                        {planInfo.coberturas.map((cob, i) => (
                                            <span
                                                key={i}
                                                className={`cobertura-badge cobertura-badge--${(cob.nivelCobertura || "").toLowerCase()}`}
                                            >
                                                {cob.servicio?.nombre || "Servicio"} · {
                                                cob.nivelCobertura === "TOTAL" ? "100%" :
                                                    cob.nivelCobertura === "NO_CUBIERTA" ? "No cubierto" :
                                                        cob.porcentaje != null ? `${Math.round(cob.porcentaje * 100)}%` :
                                                            cob.tarifaFija != null ? `$${cob.tarifaFija}` : "Parcial"
                                            }
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <p className="historial-modal__sin-plan">Sin plan / obra social asignada</p>
                        )}
                    </div>
                </div>

                <div className="historial-modal__divider" />

                <p className="historial-modal__section-title">
                    <IconCalendar /> Turnos ({turnosOrdenados.length})
                </p>

                {loading && (
                    <div className="historial-modal__loading">
                        <div className="patient-state__loader" />
                        <p>Cargando historial...</p>
                    </div>
                )}

                {!loading && error && (
                    <p className="historial-modal__error">{error}</p>
                )}

                {!loading && !error && turnosOrdenados.length === 0 && (
                    <p className="historial-modal__empty">Este paciente no tiene turnos registrados.</p>
                )}

                {!loading && !error && turnosOrdenados.length > 0 && (
                    <div className="historial-modal__lista">
                        {turnosOrdenados.map((turno) => {
                            const id = turno._id || turno.id;
                            const estado = String(turno.estado || "").toLowerCase();
                            const servicios = Array.isArray(turno.servicios)
                                ? turno.servicios.map((s) => s?.nombre || "").filter(Boolean).join(", ")
                                : "";
                            const sede = turno.sede?.nombre || turno.sede || "–";
                            return (
                                <div key={id} className="historial-item">
                                    <div className="historial-item__left">
                                        <span className="historial-item__fecha">
                                            <IconClock /> {formatFechaHora(turno.fechaHora)}
                                        </span>
                                        {servicios && (
                                            <span className="historial-item__servicio">
                                                <IconStethoscope /> {servicios}
                                            </span>
                                        )}
                                        <span className="historial-item__sede">
                                            <IconMapPin /> {sede}
                                        </span>
                                    </div>
                                    <BadgeEstado estado={estado} />
                                </div>
                            );
                        })}
                    </div>
                )}

                <div className="historial-modal__footer">
                    <button className="primary-button" onClick={onClose}>
                        Cerrar
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default HistorialPacienteModal;